import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WidgetEnum } from "../../../Store/WidgetEnum";
import { EntityTypeEnum } from "../../../Store/EntityTypeEnum";
import ActionEnum from "../../../Store/ActionEnum";
import * as widgetAction from "./../../../Store/WidgetActionCreator";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { updateObjectInArray } from "../../../Utils/ObjectUtils";
import ApplicationDataHelper from "../../../Utils/ApplicationDataHelper";
import { VIEW_MODE } from "../../../Utils/GlobalValues";
import SampleData from "../../../Sample.json";
import { find, random } from "lodash";
import { getWidgetDTOList } from "../../../Store/WidgetDataSelector";
import WidgetResource from "../../Resources/WidgetResource/WidgetResource";
import { encryptText } from "../../../Utils/EncryptionDecryptionUtil";
import { randomString } from "../../../Utils/StringUtil";

export const useWidgetService = () => {
  const skInternal = sessionStorage.getItem("skInternal");
  //const applicationContext = useContext(KycApplicationContext);
  const [saveWidget, saveWidgetToDraft, completeKYC] = WidgetResource();
  //const currentHolder = applicationContext.currentHolder;
  const dispatch = useDispatch();

  const applicationContext = useContext(KycApplicationContext);
  const applicationDataHelper = ApplicationDataHelper();

  const firstHolderWidgetList = useSelector((state) =>
    getWidgetDTOList(state, EntityTypeEnum.FH),
  );
  const secondHolderWidgetList = useSelector((state) =>
    getWidgetDTOList(state, EntityTypeEnum.SH),
  );

  const checkSecondHolderHasVideoKYC = () => {
    var hasVideoKyc = false;
    if (secondHolderWidgetList) {
      let widget = find(
        secondHolderWidgetList,
        (widget) => widget.widgetShortName === WidgetEnum.VIDEOKYC,
      );
      if (widget) hasVideoKyc = true;
    }
    return hasVideoKyc;
  };

  const checkFirstHolderHasVideoKYC = () => {
    var hasVideoKyc = false;
    if (firstHolderWidgetList) {
      let widget = find(
        firstHolderWidgetList,
        (widget) => widget.widgetShortName === WidgetEnum.VIDEOKYC,
      );
      if (widget) hasVideoKyc = true;
    }
    return hasVideoKyc;
  };

  const saveWidgetData = (data, currentHolder, currentWidget, widgetList) => {
    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      //get the updated widget DTO
      let updatedWidgetDTO = getWidgetDTO(data, currentWidget);
      //console.log(updatedWidgetDTO);

      saveWidget(updatedWidgetDTO).then(
        (response) => {
          updateWidgetDTOToStore(
            data,
            currentHolder,
            widgetList,
            response.widgetDTO,
            response.isKycProcessCompleted,
          );
          onSuccess(response);
        },
        (error) => {
          onError(error);
        },
      );
    });

    return saveWidgetPromise;
  };

  /** update widget Json and return the widget DTO */
  const getWidgetDTO = (data, widgetDTO) => {
    const updatedWidgetDTO = { ...widgetDTO };
    if (widgetDTO.widgetShortName === WidgetEnum.PERSONALINFO) {
      let widgetDataJson = JSON.stringify(data.personalInfoDTO);
      widgetDTO.widgetDataJson = widgetDataJson;

      // encrypt image and path
      var requestInfo = randomString();
      updatedWidgetDTO.widgetDataJson = JSON.stringify(
        updatePersonalInfoWidgetDataJson(data.personalInfoDTO, requestInfo),
      );
      updatedWidgetDTO.requestInfo = encryptText(requestInfo, skInternal);
    }
    if (widgetDTO.widgetShortName === WidgetEnum.NOMINEE) {
      let widgetDataJson = JSON.stringify(data.nomineeWidgetDTO);
      updatedWidgetDTO.widgetDataJson = widgetDataJson;
    }
    if (widgetDTO.widgetShortName === WidgetEnum.BANKVF) {
      let widgetDataJson = JSON.stringify(data.bankAccountVerificationDTO);
      widgetDTO.widgetDataJson = widgetDataJson;

      // encrypt image and path
      var requestInfo = randomString();
      updatedWidgetDTO.widgetDataJson = JSON.stringify(
        updateBankVerificationWidgetDataJson(
          data.bankAccountVerificationDTO,
          requestInfo,
        ),
      );
      updatedWidgetDTO.requestInfo = encryptText(requestInfo, skInternal);
    }
    if (widgetDTO.widgetShortName === WidgetEnum.VIDEOKYC) {
      let widgetDataJson = JSON.stringify(data.videoKycDTO);
      updatedWidgetDTO.widgetDataJson = widgetDataJson;
    }
    //for preview widget don't update any json
    if (widgetDTO.widgetShortName === WidgetEnum.PVIEWCKYC) {
      widgetDTO.widgetDataJson = "";
      updatedWidgetDTO.widgetDataJson = "";
    }

    return updatedWidgetDTO;
  };

  const updateBankVerificationWidgetDataJson = (
    bankAccountVerificationDTO,
    randomString,
  ) => {
    if (
      !bankAccountVerificationDTO ||
      !bankAccountVerificationDTO.pennyDropDTO
    ) {
      return bankAccountVerificationDTO;
    }

    return {
      ...bankAccountVerificationDTO,
      pennyDropDTO: {
        ...bankAccountVerificationDTO.pennyDropDTO,
        bankVerificationImage: bankAccountVerificationDTO.pennyDropDTO
          .bankVerificationImage
          ? encryptText(
              randomString +
                bankAccountVerificationDTO.pennyDropDTO.bankVerificationImage,
              skInternal,
            )
          : null,
      },
    };
  };

  const updatePersonalInfoWidgetDataJson = (personalInfoDTO, randomString) => {
    if (!personalInfoDTO || !personalInfoDTO.keyPersonalInfoDTO) {
      return personalInfoDTO;
    }

    return {
      ...personalInfoDTO,
      keyPersonalInfoDTO: {
        ...personalInfoDTO.keyPersonalInfoDTO,
        addressProofImage: personalInfoDTO.keyPersonalInfoDTO?.addressProofImage
          ? encryptText(
              randomString +
                personalInfoDTO.keyPersonalInfoDTO.addressProofImage,
              skInternal,
            )
          : null,
        impairmentFileUploadDTO: {
          ...personalInfoDTO.keyPersonalInfoDTO.impairmentFileUploadDTO,

          impairmentProofFile: personalInfoDTO.keyPersonalInfoDTO
            .impairmentFileUploadDTO?.impairmentProofFile
            ? encryptText(
                randomString +
                  personalInfoDTO.keyPersonalInfoDTO.impairmentFileUploadDTO
                    .impairmentProofFile,
                skInternal,
              )
            : null,
        },
      },
      signatureUploadDTO: {
        ...personalInfoDTO.signatureUploadDTO,
        signatureImage: personalInfoDTO.signatureUploadDTO?.signatureImage
          ? encryptText(
              randomString + personalInfoDTO.signatureUploadDTO.signatureImage,
              skInternal,
            )
          : null,
      },
      taxDeclarationDTO: {
        ...personalInfoDTO.taxDeclarationDTO,
        currentOverseasAddressProofImage: personalInfoDTO.taxDeclarationDTO
          ?.currentOverseasAddressProofImage
          ? encryptText(
              randomString +
                personalInfoDTO.taxDeclarationDTO
                  .currentOverseasAddressProofImage,
              skInternal,
            )
          : null,
        visaWorkPermitImage: personalInfoDTO.taxDeclarationDTO
          ?.visaWorkPermitImage
          ? encryptText(
              randomString +
                personalInfoDTO.taxDeclarationDTO.visaWorkPermitImage,
              skInternal,
            )
          : null,
        indianPassportImage: personalInfoDTO.taxDeclarationDTO
          ?.indianPassportImage
          ? encryptText(
              randomString +
                personalInfoDTO.taxDeclarationDTO.indianPassportImage,
              skInternal,
            )
          : null,
        chequeImage: personalInfoDTO.taxDeclarationDTO?.chequeImage
          ? encryptText(
              randomString + personalInfoDTO.taxDeclarationDTO.chequeImage,
              skInternal,
            )
          : null,
      },
    };
  };

  /** Update Widget DTO List */
  const updateWidgetDTOList = (currentHolder, currentWidgetDTO, widgetList) => {
    //update widget in the  local list
    updateObjectInArray(
      widgetList,
      currentWidgetDTO,
      (obj) => obj.widgetShortName === currentWidgetDTO.widgetShortName,
    );

    if (currentHolder.entityTypeShortName === EntityTypeEnum.FH) {
      dispatch(
        widgetAction.createAction(
          ActionEnum.UPDATE_FIRST_HOLDER_WIDGET_LIST,
          widgetList,
        ),
      );
    } else {
      dispatch(
        widgetAction.createAction(
          ActionEnum.UPDATE_SECOND_HOLDER_WIDGET_LIST,
          widgetList,
        ),
      );
    }
  };

  /**
   * update Is KycProcess Completed
   * @param {boolean} isKycProcessCompleted
   */
  const updateIsKycProcessCompleted = (isKycProcessCompleted) => {
    dispatch(
      widgetAction.createAction(
        ActionEnum.UPDATE_IS_KYC_PROCESS_COMPLETED,
        isKycProcessCompleted,
      ),
    );
  };

  /** Update Holder data in Store */
  const updateHolderDataInStore = (currentHolder, data) => {
    if (currentHolder.entityTypeShortName === EntityTypeEnum.FH) {
      dispatch(
        widgetAction.createAction(ActionEnum.UPDATE_FIRST_HOLDER_DATA, data),
      );
    } else {
      dispatch(
        widgetAction.createAction(ActionEnum.UPDATE_SECOND_HOLDER_DATA, data),
      );
    }
  };

  /** save widget data to draft and update in the store */
  const saveWidgetDataToDraft = (
    data,
    currentHolder,
    currentWidget,
    widgetList,
    currentTabName,
    suppressSuccessToast,
  ) => {
    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      //get the updated widget DTO
      let updatedWidgetDTO = getWidgetDTO(data, currentWidget);
      saveWidgetToDraft(
        updatedWidgetDTO,
        currentTabName,
        suppressSuccessToast,
      ).then(
        (response) => {
          updateWidgetDTOToStore(
            data,
            currentHolder,
            widgetList,
            response.widgetDTO,
            response.isKycProcessCompleted,
          );
          onSuccess();
        },
        (error) => {
          onError(error);
        },
      );
    });

    return saveWidgetPromise;
  };

  /** save widget data to draft and update in the store */
  const completeKyc = (data, currentHolder, currentWidget, widgetList) => {
    let saveWidgetPromise = new Promise(function (onSuccess, onError) {
      //get the updated widget DTO
      let updatedWidgetDTO = getWidgetDTO(data, currentWidget);
      completeKYC(updatedWidgetDTO).then(
        (response) => {
          applicationContext.setWidgetShortNameToShow(WidgetEnum.ESIGNTC);
          dispatchApplicationDetailsToStore(response);
          onSuccess(response);
        },
        (error) => {
          onError(error);
        },
      );
    });

    return saveWidgetPromise;
  };

  /**
   * update widget store data
   * @param {object} data
   * @param {object} currentHolder
   * @param {object} currentWidget
   * @param {array} widgetList
   */
  const updateWidgetStoreData = (
    data,
    currentHolder,
    currentWidget,
    widgetList,
    isKycProcessCompleted,
  ) => {
    let updatedWidgetDTO = getWidgetDTO(data, currentWidget);
    updateWidgetDTOToStore(
      data,
      currentHolder,
      widgetList,
      updatedWidgetDTO,
      isKycProcessCompleted,
    );
  };

  /**
   * update widget store data
   * @param {object} data
   * @param {object} currentWidget
   * @param {array} widgetList
   * @param {object} updatedWidgetDTO
   */
  const updateWidgetDTOToStore = (
    data,
    currentHolder,
    widgetList,
    updatedWidgetDTO,
    isKycProcessCompleted,
  ) => {
    updateWidgetDTOList(currentHolder, updatedWidgetDTO, widgetList);
    updateIsKycProcessCompleted(isKycProcessCompleted);
    updateHolderDataInStore(currentHolder, data);
  };

  function dispatchApplicationDetailsToStore(applicationDTO) {
    var holderList = SampleData.kycApplicationEntityDTOList;
    var isKycProcessCompleted = false;
    if (applicationDTO !== null && applicationDTO !== "") {
      //applicationContext.setApplicationDTO(applicationDTO);
      holderList = applicationDTO.kycApplicationEntityDTOList;
      var mode = getMode(applicationDTO);
      applicationContext.setMode(applicationDTO.mode);
      applicationContext.setDisableForm(getDisableForm(applicationDTO));
      if (applicationDTO.kycProcessCompleted != null) {
        isKycProcessCompleted = applicationDTO.kycProcessCompleted;
      }
    }

    let firstHolderData = applicationDataHelper.constructHolderData(
      applicationDTO,
      EntityTypeEnum.FH,
    );
    let secondHolderData = applicationDataHelper.constructHolderData(
      applicationDTO,
      EntityTypeEnum.SH,
    );

    dispatch(widgetAction.SetApplicationData(applicationDTO));
    dispatch(
      widgetAction.createAction(
        ActionEnum.UPDATE_FIRST_HOLDER_DATA,
        firstHolderData,
      ),
    );
    dispatch(
      widgetAction.createAction(
        ActionEnum.UPDATE_SECOND_HOLDER_DATA,
        secondHolderData,
      ),
    );
    dispatch(
      widgetAction.createAction(
        ActionEnum.UPDATE_FIRST_HOLDER_WIDGET_LIST,
        applicationDataHelper.getWidgetDTOList(
          applicationDTO,
          EntityTypeEnum.FH,
        ),
      ),
    );
    dispatch(
      widgetAction.createAction(
        ActionEnum.UPDATE_SECOND_HOLDER_WIDGET_LIST,
        applicationDataHelper.getWidgetDTOList(
          applicationDTO,
          EntityTypeEnum.SH,
        ),
      ),
    );
    dispatch(
      widgetAction.createAction(ActionEnum.UPDATE_HOLDER_LIST, holderList),
    );
    dispatch(
      widgetAction.createAction(
        ActionEnum.UPDATE_IS_KYC_PROCESS_COMPLETED,
        isKycProcessCompleted,
      ),
    );
  }

  const getMode = (data) => data.mode;

  const getDisableForm = (data) => {
    return data.mode === VIEW_MODE ? true : data.kycCompleted ? true : false;
  };

  return {
    saveWidgetData: saveWidgetData,
    getWidgetDTO: getWidgetDTO,
    saveWidgetDataToDraft: saveWidgetDataToDraft,
    updateWidgetStoreData: updateWidgetStoreData,
    completeKyc: completeKyc,
    dispatchApplicationDetailsToStore: dispatchApplicationDetailsToStore,
    updateWidgetDTOToStore: updateWidgetDTOToStore,
    checkSecondHolderHasVideoKYC: checkSecondHolderHasVideoKYC,
    checkFirstHolderHasVideoKYC: checkFirstHolderHasVideoKYC,
  };
};
